module.exports = __webpack_public_path__ + "static/media/garph-line.7a33f3d6.svg";